import { render, staticRenderFns } from "./HistoricalEvent.vue?vue&type=template&id=1c80ece2&scoped=true&"
import script from "./HistoricalEvent.vue?vue&type=script&lang=js&"
export * from "./HistoricalEvent.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalEvent.vue?vue&type=style&index=0&id=1c80ece2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c80ece2",
  null
  
)

export default component.exports